import { Button, TextField } from "@dash/form";
import { SelectDialog } from "@dash/select";
import { useToast } from "@dash/toast";
import { useProfiles } from "@megarax/features";
import { useState } from "react";

import { Macroregion } from "@megaron/crm-contracts";
import { useClientManager } from "@megaron/react-clients";

import { CustomersButton } from "./CustomersButton";

type Props = {
  macroregion?: Macroregion;
  onSuccess: () => void;
};

export const SaveMacroregion: React.FC<Props> = (props) => {
  const toast = useToast();
  const { allProfiles } = useProfiles();

  const saveMacroegion = useClientManager("crm").saveMacroregion().useMutation();
  const regions = useClientManager("crm").regionsQuery().useQuery({}).data?.items;

  const [name, setName] = useState<string>(props.macroregion?.name ?? "");
  const [emailsList, setEmailsList] = useState<string[]>(props.macroregion?.emails ?? []);
  const [selectedRegions, setSelectedRegions] = useState<string[]>(props.macroregion?.regions ?? []);

  const addCustomerMutation = async () => {
    saveMacroegion.mutate(
      {
        name,
        emails: emailsList.map((email) => email.toString()),
        regions: selectedRegions.map((region) => region.toString()),
      },
      {
        onSuccess: () => {
          props.onSuccess();
        },
        onError: (e) => {
          switch (e) {
            case "NoRegionProvided":
              toast.error("Error", "Nie podano żadnego regionu");
              break;
            case "NoEmailProvided":
              toast.error("Error", "Nie podano żadnej uprawnionej osoby");
              break;
            default:
              toast.error("Error", "Coś poszło nie tak");
          }
        },
      },
    );
  };

  const regionOptions = regions
    ? regions.map((region) => ({
        label: `${region.name}`,
        value: region.name,
      }))
    : [];

  const emailsOptions = allProfiles?.map((profile) => ({
    label: profile.firstName ? `${profile.firstName} ${profile.lastName}` : `${profile.email}`,
    value: profile.email,
  }));

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <TextField
        css={{ input: { height: "46px" } }}
        label={"Makroregion"}
        value={name}
        onChange={(value) => setName(value)}
        autoFocus
      />

      <SelectDialog
        label="Regiony"
        initiallySelectedValues={selectedRegions}
        options={regionOptions}
        onSelectedChange={(options) => setSelectedRegions(options.map((option) => option.value))}
        variant="multi-select"
      />
      <SelectDialog
        label="Osoby uprawnione"
        initiallySelectedValues={emailsList}
        options={emailsOptions ?? []}
        onSelectedChange={(options) => setEmailsList(options.map((option) => option.value))}
        variant="multi-select"
      />

      {props.macroregion && (
        <CustomersButton regions={props.macroregion.regions} customerCount={props.macroregion?.customerCount} />
      )}

      <Button
        css={{ alignSelf: "flex-end", margin: "0.25rem 0" }}
        onClick={addCustomerMutation}
        isLoading={saveMacroegion.isLoading}
      >
        Zapisz
      </Button>
    </div>
  );
};
